<template>
    <mdb-container fluid>
        <h3 class="text-center font-weight-bold mb-5 mt-n4">
           Оперативная информация
        </h3>
        <section class="premium-cards">
            <mdb-row>
                <mdb-col xl="3" md="6" class="mb-4 preimum-cards__item" v-for="item in premium" :key="item.mark">
                    <mdb-card cascade class="cascading-admin-card">
                        <div class="admin-up">
                            <mdb-icon
                                    icon="money-bill-alt"
                                    far
                                    class="primary-color card-icon"
                            ></mdb-icon>
                            <div class="data">
                                <p class="text-uppercase">{{item.mark}}</p>
                                <h4 class="font-weight-bold dark-grey-text mb-0"> {{ formatPrice(item.premium)}} </h4>
                                <div style="font-size: 14px" class="grey-text"> млн. сум </div>
                            </div>
                        </div>

                        <mdb-card-body cascade>
                            <div class="progress-wrapper mb-3">
                                <div class="progress mr-2">
                                    <div
                                            class="progress-bar bg-primary"
                                            role="progressbar"
                                            :style="'width: ' + (item.premium/(item.plan/100)) + '%'"
                                            aria-valuenow="25"
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                    ></div>
                                </div>
                                <div class="progress__percent">{{ (item.premium ? ((item.premium/(item.plan/100)).toFixed(1) ) : 0) + "%" }}</div>
                            </div>
                            <mdb-card-text>Plan:  <strong> {{ formatPrice(item.plan) }} </strong></mdb-card-text>
                        </mdb-card-body>
                    </mdb-card>
                </mdb-col>
            </mdb-row>
        </section>
        <section class="mb-5">
            <!--Card-->
            <mdb-card cascade narrow>
                <!--Section: Chart-->
                <section>
                    <!--Grid row-->
                    <mdb-row class="mb-4">
                        <!--Grid column-->
                        <mdb-col xl="5" md="12" class="mr-0">
                            <!--Card image-->
                            <div
                                    class="view view-cascade gradient-card-header primary-gradient light-blue lighten-1"
                            >
                                <h4 class="h4-responsive font-weight-bold mb-0">
                                    Страховые продукты
                                </h4>
                            </div>
                            <!--/Card image-->
                            <!--Card content-->
                            <mdb-card-body cascade class="pb-0">
                                <mdb-select
                                        @getValue="onInsProductTableYearChange"
                                        label="Выбрать год"
                                        :options="premiumsByMonthYearOptions"
                                />
                                <!--Panel data-->
                                <div class="card-body pt-2">
                                    <table class="table no-header table--small">
                                        <thead>
                                            <tr>
                                                <th>Наименование</th>
                                                <th style="text-align: right"> Премии</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in products" :key="item.productId">
                                                <td>{{item.productName}}</td>
                                                <td align="right">{{formatPrice(item.premium) }}</td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                        <tr>
                                            <th>Итого</th>
                                            <th style="text-align: right"> {{formatPrice(insProductTableTotal)}} </th>
                                        </tr>
                                        </tfoot>
                                    </table>
                                </div>
                                <!--/Panel data-->
                            </mdb-card-body>
                            <!--/.Card content-->
                        </mdb-col>
                        <!--Grid column-->
                        <!--Grid column-->
                        <mdb-col xl="7" md="12" class="mb-4">
                            <!--Card image-->
                            <div class="view view-cascade gradient-card-header primary-gradient">
                                <!-- Chart -->
                                <mdb-pie-chart v-if="!!this.pieChartData.labels.length && !!this.pieChartData.datasets[0].data.length"
                                        :data="pieChartData"
                                        :options="pieChartOptions"
                                        :height="300"
                                ></mdb-pie-chart>
                            </div>
                            <!--/Card image-->
                        </mdb-col>
                        <!--Grid column-->
                    </mdb-row>
                    <!--Grid row-->

                </section>
                <!--Section: Chart-->
            </mdb-card>
            <!--/.Card-->
        </section>
        <section>
            <div class="text-white primary-gradient card-header">
                <h3>Филиалы</h3>
            </div>
            <div class="bg-white px-4 py-1">
                <mdb-select
                        style="max-width:200px"
                        @getValue="onChangeDateBranch"
                        label="Выбрать год"
                        :options="premiumsByMonthYearOptions2"
                />
                <div class="table-wrapper">
                    <sorted-table :values="branchesData = this.tableData.rows" class="table">
                        <thead>
                        <tr>
                            <th scope="col" style="text-align: left; width: 10rem;">
                                <sort-link name="order">{{ this.tableData.columns[0].label }}</sort-link>
                            </th>
                            <th scope="col" style="text-align: left; width: 10rem;">
                                <sort-link name="branch_name">{{ this.tableData.columns[1].label }}</sort-link>
                            </th>
                            <th scope="col" style="text-align: end; width: 10rem;">
                                <sort-link name="plan">{{ this.tableData.columns[2].label }}</sort-link>
                            </th>
                            <th scope="col" style="text-align: end; width: 10rem;">
                                <sort-link name="premium">{{ this.tableData.columns[3].label }}</sort-link>
                            </th>
                            <th scope="col" style="text-align: end; width: 10rem;">
                                <sort-link name="percent">{{ this.tableData.columns[4].label }}</sort-link>
                            </th>
                        </tr>
                        </thead>
                        <template #body="{ values }">
                            <tbody>
                            <tr v-for="item in branchesData" :key="item.order">
                                <td :class="item.percent > 100 ? 'table-color py-2 ' : 'py-2'" >{{ item.order }}</td>
                                <td :class="item.percent > 100 ? 'table-color py-2 ' : 'py-2'" >{{ item.branch_name }}</td>
                                <td :class="item.percent > 100 ? 'table-color py-2 text-right' : 'py-2 text-right'">{{ item.plan }}</td>
                                <td :class="item.percent > 100 ? 'table-color py-2 text-right' : 'py-2 text-right'">{{ item.premium }}</td>
                                <td :class="item.percent > 100 ? 'table-color py-2 text-right' : 'py-2 text-right'">{{ item.percent }}</td>
                            </tr>
                            </tbody>
                        </template>
                    </sorted-table>
                    <table class="table totalTable">
                        <thead>
                            <tr>
                                <th style="text-align: left; width: 10rem; border-bottom: 0; border-top: 2px solid #e2e2e2;" class="font-weight-bold h5">Итого:</th>
                                <th style="text-align: left; width: 10rem; border-bottom: 0; border-top: 2px solid #e2e2e2; opacity: 0" class="font-weight-bold h5">names</th>
                                <th style="text-align: right; width: 10rem; border-bottom: 0; border-top: 2px solid #e2e2e2;" scope="col" class="font-weight-bold h5">{{this.totalPlan}}</th>
                                <th style="text-align: right; width: 10rem; border-bottom: 0; border-top: 2px solid #e2e2e2;" scope="col" class="font-weight-bold h5">{{this.totalPremium}}</th>
                                <th style="text-align: right; width: 10rem; border-bottom: 0; border-top: 2px solid #e2e2e2;" scope="col" class="font-weight-bold h5">{{totalPercent}}</th>
                            </tr>
                        </thead>
                    </table>
                </div>

            </div>

        </section>
        <section class="my-5">
            <!--Card-->
            <mdb-card cascade narrow>
                <section>
                    <!--Grid row-->
                    <mdb-row>
                        <!--Grid column-->
                        <mdb-col xl="5" lg="12" class="mr-0">
                            <!--Card image-->
                            <div
                                    class="view view-cascade gradient-card-header primary-gradient light-blue lighten-1"
                            >
                                <h2 class="h2-responsive mb-0">По месяцам</h2>
                            </div>
                            <!--/Card image-->

                            <!--Card content-->
                            <div class="card-body pt-2">
                                <mdb-select
                                        @getValue="onChangeYearPremiumByMonth"
                                        label="Выбрать год"
                                        :options="premiumsByMonthYearOptions3"
                                />
                                <table v-if="premiumsByMonth" class="table no-header table--small">
                                    <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Месяц</th>
                                        <th style="text-align: right"> Премии</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="item in premiumsByMonth" :key="item.month">
                                        <td>{{item.month}}</td>
                                        <td>{{item.monthName}}</td>
                                        <td align="right">{{formatPrice(item.premium) }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!--/.Card content-->
                        </mdb-col>
                        <!--Grid column-->

                        <!--Grid column-->
                        <div class="col-xl-7 col-lg-12 mb-4">
                            <!--Card image-->
                            <mdb-view cascade gradient="blue" class="primary-gradient">
                                <!-- Chart -->
                                <mdb-line-chart v-if="!!this.lineChartData.labels.length && !!this.lineChartData.datasets[0].data.length"
                                        :data="lineChartData"
                                        :options="lineChartOptions"
                                        :height="300"
                                ></mdb-line-chart>
                            </mdb-view>
                            <!--/Card image-->
                        </div>
                        <!--Grid column-->
                    </mdb-row>
                    <!--Grid row-->
                 </section>
            </mdb-card>
        </section>
        <section class="my-5">
            <!--Card-->
            <mdb-card cascade narrow>
                <section>
                    <!--Grid row-->
                    <mdb-row>
                        <!--Grid column-->
                        <mdb-col xl="5" lg="12" class="mr-0">
                            <!--Card image-->
                            <div
                                    class="view view-cascade gradient-card-header primary-gradient light-blue lighten-1"
                            >
                                <h2 class="h2-responsive mb-0">По годам</h2>
                            </div>
                            <!--/Card image-->

                            <!--Card content-->
                            <div class="card-body pt-2">
                                <table class="table no-header table--small">
                                    <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Год</th>
                                        <th style="text-align: right"> Премии</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item, index ) in premiumsByYear" :key="item.year">
                                        <td>{{index +1}}</td>
                                        <td>{{item.year}}</td>
                                        <td align="right">{{formatPrice(item.premium) }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!--/.Card content-->
                        </mdb-col>
                        <!--Grid column-->

                        <!--Grid column-->
                        <div class="col-xl-7 col-lg-12 mb-4">
                            <!--Card image-->
                            <mdb-view cascade gradient="blue" class="primary-gradient">
                                                              <!-- Chart -->
                                <mdb-bar-chart v-if="!!this.barChartData.labels.length && !!this.barChartData.datasets[0].data.length"
                                        :data="barChartData"
                                        :options="barChartOptions"
                                        :width="600"
                                        :height="300"
                                ></mdb-bar-chart>
                            </mdb-view>
                            <!--/Card image-->
                        </div>
                        <!--Grid column-->
                    </mdb-row>
                    <!--Grid row-->
                </section>
            </mdb-card>
        </section>
    </mdb-container>
</template>

<script>
    import {
        mdbContainer,
        mdbRow,
        mdbCol,
        mdbCard,
        mdbCardBody,
        mdbCardText,
        mdbIcon,
        mdbPieChart,
        mdbLineChart,
        mdbBarChart,
        mdbView,
        mdbSelect
    } from "mdbvue";
    import randomcolor from "randomcolor";
    import store from "../store";
    export default {
        name: "Dashboard",
        components:{
            mdbContainer,
            mdbRow,
            mdbCol,
            mdbCard,
            mdbCardBody,
            mdbCardText,
            mdbIcon,
            mdbPieChart,
            mdbLineChart,
            mdbBarChart,
            mdbView,
            mdbSelect
        },
        data() {
            return {
                premium: null,
                products: null,
                branches: null,
                premiumsByMonth:null,
                premiumsByYear: null,
                premiumsByMonthYearOptions: [],
                premiumsByMonthYearOptions2: [],
                premiumsByMonthYearOptions3: [],
                insProductTableTotal: null,
                currentYear: new Date().getFullYear(),
                branchesData: [],
                todayDate: null,
                totalPlan: 0,
                totalPremium: 0,
                totalPercent: 0,
                pieChartData: {
                    labels: [],
                    datasets: [
                        {
                            data: [],
                            backgroundColor: [],
                            hoverBackgroundColor: []
                        }
                    ]
                },
                pieChartOptions: {
                    responsive: true,
                    legend:{
                      position: "right"
                    },
                    maintainAspectRatio: false,
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            label: function (tooltipItems,data) {
                                var label = data.labels[tooltipItems.index]
                                return label;
                            }
                        }
                    }
                },
                tableData: {
                    columns: [
                        {
                            label: '#',
                            field: 'order',
                            sort: 'asc'
                        },
                        {
                            label: 'Название филиала',
                            field: 'branch_name',
                            sort: 'asc'
                        },
                        {
                            label: 'План',
                            field: 'plan',
                            sort: 'asc'
                        },
                        {
                            label: 'Премия',
                            field: 'premium',
                            sort: 'asc'
                        },
                        {
                            label: '%',
                            field: 'percent',
                            sort: 'asc'
                        }
                    ],
                    rows: []
                },
                lineChartData: {
                    labels: [],
                    datasets: [
                        {
                            label: null,
                            backgroundColor: "rgba(255,255,255,0.4)",
                            borderColor: "#fff",
                            pointBackgroundColor: "transparent",
                            borderWidth: 2,
                            pointBorderColor: "#fff",
                            pointBorderWidth: 1,
                            data: []
                        }
                    ]
                },
                lineChartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        xAxes: [
                            {
                                gridLines: {
                                    display: true,
                                    color: "rgba(255, 255, 255, 0.2)"
                                }
                            }
                        ],
                        yAxes: [
                            {
                                gridLines: {
                                    display: true,
                                    color: "rgba(255, 255, 255, 0.2)"
                                }
                            }
                        ]
                    }
                },
                barChartData: {
                    labels: [],
                    datasets: [
                        {
                            label: false,
                            data: [],
                            backgroundColor: "rgba(255, 255, 255, 0.3)",
                            borderColor: "#fff",
                            borderWidth: 1
                        }
                    ]
                },
                barChartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: false
                    },
                    scales: {
                        xAxes: [
                            {
                                gridLines: {
                                    display: true,
                                    color: "rgba(0, 0, 0, 0.1)"
                                }
                            }
                        ],
                        yAxes: [
                            {
                                gridLines: {
                                    display: true,
                                    color: "rgba(0, 0, 0, 0.1)"
                                },
                                ticks: {
                                    beginAtZero: true,
                                    min: 0
                                }
                            }
                        ]
                    }
                },
            }
        },
        methods: {
            formatPrice: function( rawPrice){
                if(rawPrice) {
                    var x = (rawPrice/1000).toFixed(1)
                    var parts = x.toString().split(".");
                    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                    return parts.join(".");
                }
                return 0
            },
            onChangeYearPremiumByMonth(value) {
                if(value !== null){
                    this.$http.post(process.env.VUE_APP_URL + '/services/bi_DataService/getByMonth', {
                        "year": value
                    }).then(response => {
                        this.premiumsByMonth = response.data

                        let labels = [];
                        let lineChartData = []

                        for (var item in this.premiumsByMonth){
                            labels.push(this.premiumsByMonth[item].monthName)
                            lineChartData.push((this.premiumsByMonth[item].premium /1000).toFixed(1))
                        }

                        this.lineChartData = {
                            labels: labels,
                            datasets: [
                                {
                                    label: value,
                                    data: lineChartData
                                }
                            ]
                        }
                    });
                }
            },
            onInsProductTableYearChange(value) {
                if(value !== null){
                    this.$http.post(process.env.VUE_APP_URL + '/services/bi_DataService/getByProduct', {
                        "year": value
                    }).then(response => {
                        this.products = response.data
                        var premiumSum = 0

                        for (var i in this.products){
                            premiumSum += this.products[i].premium
                        }
                        this.insProductTableTotal = premiumSum
                        let labels = this.products.map(item => item.productName)

                        var premiumArray = []

                        for (var k in this.products){
                            var percent = (((this.products[k].premium) / premiumSum) * 100 ).toFixed(1)
                            premiumArray.push(percent)
                            labels[k] += ": " + percent + "%"
                        }

                        this.pieChartData = {
                            labels: labels,
                            datasets: [
                                {
                                    data: premiumArray,
                                    backgroundColor: randomcolor({hue: 'random',luminosity: 'dark', count: this.products.length}),
                                    hoverBackgroundColor: randomcolor({hue: 'blue', count: this.products.length})
                                }
                            ]
                        }
                    });
                }

            },
            onChangeDateBranch(value){

                this.$http.post(process.env.VUE_APP_URL + '/services/bi_DataService/getByBranch', {
                    "date": '31' + '12' + value
                }).then(response => {
                    this.branchesData = response.data
                    this.tableData.rows = [];
                    this.totalPlan = 0;
                    this.totalPremium = 0;
                    this.totalPercent = 0;

                    for (var item in this.branchesData){

                        if (!this.branchesData[item].plan){
                            this.branchesData[item].plan = 0;
                        }

                        this.totalPlan += parseFloat(this.branchesData[item].plan) / 1000;
                        this.totalPremium += parseFloat(this.branchesData[item].premium) / 1000;

                        this.tableData.rows.push({
                            order:parseInt(item) + 1,
                            branch_name:this.branchesData[item].branchName,
                            plan: this.branchesData[item].plan ? (parseFloat(this.branchesData[item].plan) / 1000).toFixed(2) : '-',
                            premium: (parseFloat(this.branchesData[item].premium) /1000).toFixed(2),
                            percent: this.branchesData[item].plan ? (this.branchesData[item].premium / (this.branchesData[item].plan / 100)).toFixed(1) : '-'
                        })
                    }

                    this.totalPercent = this.totalPlan ? (this.totalPremium / (this.totalPlan / 100)).toFixed(1) : '-';

                    this.totalPlan = this.totalPlan ?  this.totalPlan.toFixed(2) : '-';

                    this.totalPremium  = this.totalPremium.toFixed(2);


                });
            },
            getInsProductData(year){
                this.$http.post(process.env.VUE_APP_URL + '/services/bi_DataService/getByProduct', {
                    "year": year // TODO: make year dynamic
                }).then(response => {
                    this.products = response.data

                    var premiumSum = 0
                    var premiumArray = []

                    for (var i in this.products){
                        premiumSum += this.products[i].premium
                    }
                    this.insProductTableTotal = premiumSum

                    let labels = this.products.map(item => item.productName)


                    for (var k in this.products){
                        var percent = (((this.products[k].premium) / premiumSum) * 100 ).toFixed(1)
                        premiumArray.push(percent)
                        labels[k] += ": " + percent + "%"
                    }

                    this.pieChartData = {
                        labels: labels,
                        datasets: [
                            {
                                data: premiumArray,
                                backgroundColor: randomcolor({hue: 'random',luminosity: 'dark', count: this.products.length}),
                                hoverBackgroundColor: randomcolor({hue: 'blue', count: this.products.length})
                            }
                        ]
                    }
                });
            },
            getInsPremiumData(date) {
                this.$http.post(process.env.VUE_APP_URL + '/services/bi_DataService/getPremium', {
                    "date": date
                }).then(response => (this.premium = response.data));
            },
            getBranchesData(date) {
                this.$http.post(process.env.VUE_APP_URL + '/services/bi_DataService/getByBranch', {
                    "date": date
                }).then(response => {
                    this.branchesData = response.data
                    for (var item in this.branchesData){

                        if (!this.branchesData[item].plan){
                            this.branchesData[item].plan = 0;
                        }

                        this.totalPlan += parseFloat(this.branchesData[item].plan) / 1000;
                        this.totalPremium += parseFloat(this.branchesData[item].premium) / 1000;

                        this.tableData.rows.push({
                            order: parseInt(item) + 1,
                            branch_name: this.branchesData[item].branchName,
                            plan: (parseFloat(this.branchesData[item].plan) / 1000).toFixed(2),
                            premium: (parseFloat(this.branchesData[item].premium) / 1000).toFixed(2),
                            percent: this.branchesData[item].plan ? (this.branchesData[item].premium / (this.branchesData[item].plan / 100)).toFixed(1) : '-'
                        });
                    }

                    this.totalPlan = this.totalPlan.toFixed(2)
                    this.totalPremium  = this.totalPremium.toFixed(2);
                    this.totalPercent = this.totalPlan ? (this.totalPremium / (this.totalPlan / 100)).toFixed(1) : '-'
                });
            },
            getPremiumByMonthData(year) {
                this.$http.post(process.env.VUE_APP_URL + '/services/bi_DataService/getByMonth', {
                    "year": year
                }).then(response => {
                    this.premiumsByMonth = response.data
                    for (var item in this.premiumsByMonth){
                        this.lineChartData.labels.push(this.premiumsByMonth[item].monthName)
                        this.lineChartData.datasets[0].data.push((this.premiumsByMonth[item].premium /1000).toFixed(1))
                    }
                    this.lineChartData.datasets[0].label = this.currentYear;

                });
            },
            getPremiumByYearData() {
                this.$http.post(process.env.VUE_APP_URL + '/services/bi_DataService/getByYear')
                    .then(response => {
                        this.premiumsByYear = response.data

                        for (var item in this.premiumsByYear){
                            this.barChartData.labels.push(this.premiumsByYear[item].year)
                            this.barChartData.datasets[0].data.push((this.premiumsByYear[item].premium /1000).toFixed(1))
                            this.premiumsByMonthYearOptions.push({value:this.premiumsByYear[item].year, text: this.premiumsByYear[item].year, selected: this.premiumsByYear[item].year==this.currentYear })
                            this.premiumsByMonthYearOptions2.push({value:this.premiumsByYear[item].year, text: this.premiumsByYear[item].year, selected: this.premiumsByYear[item].year==this.currentYear })
                            this.premiumsByMonthYearOptions3.push({value:this.premiumsByYear[item].year, text: this.premiumsByYear[item].year, selected: this.premiumsByYear[item].year==this.currentYear })
                        }

                        this.premiumsByMonthYearOptions = this.premiumsByMonthYearOptions.reverse();
                        this.premiumsByMonthYearOptions2 = this.premiumsByMonthYearOptions2.reverse();
                        this.premiumsByMonthYearOptions3 = this.premiumsByMonthYearOptions3.reverse();


                    });
            }
        },
        computed: {
            getToday: function () {
              var today =  new Date()
              var dd = ("0" + today.getDate()).slice(-2)
              var mm = ("0" + (today.getMonth()+1)).slice(-2)
              var yyyy = today.getFullYear()
              today  = "" + dd + mm + yyyy;
              return today
            },
            getTodayDatePickerFormat: function () {
                var today =  new Date()
                var dd = ("0" + today.getDate()).slice(-2)
                var mm = ("0" + (today.getMonth()+1)).slice(-2)
                var yyyy = today.getFullYear()
                today  = yyyy +"-"+mm+"-"+dd
                return today
            }
        },
        created() {

            this.todayDate = this.getTodayDatePickerFormat
            this.getInsPremiumData(this.getToday)

            this.getInsProductData(this.currentYear)

            this.getBranchesData(this.getToday)

            this.getPremiumByMonthData(this.currentYear)

            this.getPremiumByYearData()

            store.commit('setBreadcrumbs',['Главная']);
        //
        }
    }
</script>

<style scoped>
    .progress-wrapper{
        display: flex;
        align-items: center;
    }
    .progress-wrapper .progress{
        flex-grow: 1;
    }
    .progress__percent{
        flex-basis: 50px;
    }
    .table--small td{
        padding-top: 0;
        padding-bottom: 0;
        font-size: 1.1rem;
    }
    .premium-cards .preimum-cards__item:first-child .card-icon{
        background: rgb(12,87,166) !important;
    }
    .premium-cards .preimum-cards__item:nth-child(2) .card-icon{
        background: rgb(0,110,180) !important;
    }
    .premium-cards .preimum-cards__item:nth-child(3) .card-icon{
        background: rgb(0,163,211) !important;
    }
    .premium-cards .preimum-cards__item:nth-child(4) .card-icon{
        background: rgb(199,220,233) !important;
    }
    @media only screen and (max-width: 900px) {
        .table-wrapper{
            display: block;
            width: 100%;
            overflow-x: auto;
        }
        .totalTable thead tr th{
            font-size: 16px;
        }
    }

</style>
